// External Packages
import { useContext } from "react";

// Internal Packages
import { UtilityContext } from "../../context/util-context";
import VehicleFlags from "./VehicleFlags";
import { isoDateToString } from "../../util/format-date";

export default function VehicleCard({
  vehicle,
  onClick = false,
  fetchLocations,
}) {
  const { navigate } = useContext(UtilityContext);

  const classNames = () => {
    let classes =
      "lg:flex space-x-4 justify-between items-center text-sm pill grid grid-cols-2 text-stone-200";
    if (!vehicle.available) classes += " border-stone-600 opacity-60";
    else if (vehicle.status === "maintenance")
      classes += " border-yellow-500 animate-pulse";
    else if (!vehicle.booking) classes += " border-green-600";
    return classes;
  };

  const clickHandler = (e) => {
    if (onClick) onClick(vehicle.id);
    else navigate(`/vehicles/info?id=${vehicle.id}`, e);
  };

  return (
    <div onClick={(e) => clickHandler(e)} className={classNames()}>
      <img
        alt="vehicle-image"
        src={vehicle.cornerImage}
        className="w-20 lg:w-24"
      />
      <div className="grid lg:w-32">
        <p className="font-semibold truncate text-stone-200">
          {vehicle.year} {vehicle.make?.name} {vehicle.model}
        </p>
        <p className="font-semibold truncate text-stone-400">{vehicle.trim}</p>
      </div>
      <div className="grid">
        <p className="">{vehicle.vin}</p>
        <p className="text-stone-400">
          {vehicle.license} {vehicle.licenseState} - {vehicle.keyTag}
        </p>
      </div>
      <div className="hidden mx-auto text-center lg:block">
        <p className="font-bold font-Play text-stone-200">
          {vehicle.plan?.name}
        </p>
        <p className="text-stone-400">${vehicle.rate}</p>
      </div>

      {vehicle.booking ? (
        <div className="grid">
          <p className="truncate">
            {vehicle.booking.customer?.firstName}{" "}
            {vehicle.booking.customer?.lastName}
          </p>
          <p className="text-stone-400">
            {isoDateToString(vehicle.booking.startDate, "MM/dd")} -{" "}
            {isoDateToString(vehicle.booking.endDate, "MM/dd")}
          </p>
        </div>
      ) : !fetchLocations ? (
        <div className="text-yellow-600">Locations Off</div>
      ) : vehicle.fetched ? (
        vehicle.lot ? (
          <p className="text-green-600">{vehicle.lot}</p>
        ) : vehicle.location ? (
          <p className="text-yellow-500">Not on Lot</p>
        ) : (
          <p className="warning animate-pulse">
            Location
            <br />
            Unknown
          </p>
        )
      ) : (
        <div className="w-32 h-6 rounded-md animate-pulse bg-stone-700"></div>
      )}

      {vehicle.application?.partner?.name ? (
        <div>
          <p className="truncate text-stone-400 lg:max-w-[120px]">
            {vehicle.application?.partner?.name}
          </p>
          <p className="truncate text-stone-400 text-center lg:max-w-[120px]">
            ${vehicle.application?.monthlyPayment?.toFixed(2) || "-"}
          </p>
        </div>
      ) : (
        <p className="warning animate-pulse">No Partner Asssigned</p>
      )}

      <div className="">
        <VehicleFlags vehicle={vehicle} />
      </div>
    </div>
  );
}
